import { type FC, lazy, Suspense } from 'react';
import {
    PdpSharedDetail,
    type PdpSharedDetailProps,
} from '../shared/PdpSharedDetail/PdpSharedDetail.tsx';

type Props = PdpSharedDetailProps & {
    afterDisplay: boolean;
    showOnTop?: boolean;
};

export const PdpSharedDetailLabReport: FC<Props> = ({ afterDisplay, showOnTop, ...props }) => {
    const LabReportTip = lazy(
        () =>
            import(
                /* webpackChunkName: "PdpSharedDetailLabReportTip" */ '../shared/PdpSharedDetail/PdpSharedDetailLabReportTipLazy.tsx'
            )
    );

    return (
        <>
            <PdpSharedDetail {...props} />
            {afterDisplay && (
                <Suspense fallback="">
                    <LabReportTip showOnTop={showOnTop} />
                </Suspense>
            )}
        </>
    );
};
